// Telefonnummer-Normalisierung für den KI-Telefonisten-Abgleich.
//
// WICHTIG: Diese Funktion ist ein exakter Port von `normalizeGermanPhoneNumber`
// im Backend (nextcab_mobile, functions/src/index.ts). Der KI-Telefonist matched
// eingehende Anrufer per Gleichheit auf das Feld `phoneNumberE164`. Damit der
// schnelle Index-Match greift (statt des 1000er-Fallback-Scans pro Organisation),
// MUSS das Portal die Kundennummer mit derselben Logik nach E.164 normalisieren.
// Bei Änderungen hier auch das Backend anpassen.
export function normalizeGermanPhoneNumber(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed || /^(anonymous|unknown|unbekannt|private)$/i.test(trimmed)) return null;

  let normalized = trimmed.replace(/[^\d+]/g, '');
  if (normalized.startsWith('00')) normalized = `+${normalized.slice(2)}`;
  // "+49 (0) 176 …": keine deutsche Vorwahl beginnt mit 0.
  if (normalized.startsWith('+490')) normalized = `+49${normalized.slice(4)}`;
  if (normalized.startsWith('0')) normalized = `+49${normalized.slice(1)}`;
  // Deutsche Handynummer ohne fuehrende 0 ("176 …"), sonst +1 … (Nordamerika).
  if (/^1[5-7]\d{8,9}$/.test(normalized)) normalized = `+49${normalized}`;
  if (!normalized.startsWith('+')) normalized = `+${normalized}`;
  if (!/^\+[1-9]\d{7,14}$/.test(normalized)) return null;
  return normalized;
}

// "+4917657015830" -> "+49 176 57015830" (nur zur Anzeige; gespeichert wird E.164).
export function formatE164ForDisplay(e164) {
  if (!e164) return '';
  if (e164.startsWith('+49')) {
    const rest = e164.slice(3);
    return /^1[5-7]/.test(rest) ? `+49 ${rest.slice(0, 3)} ${rest.slice(3)}` : `+49 ${rest}`;
  }
  return e164;
}

// Hinweis unter Telefonfeldern: zeigt, als welche Nummer die Anruferkennung (KI-Telefonist,
// Telefonanlage) die Eingabe liest — oder warnt, wenn sie nicht erkennbar ist. Blockiert nicht.
export function phoneRecognitionHint(value) {
  const raw = String(value || '').trim();
  if (!raw) return { error: false, text: '' };
  const e164 = normalizeGermanPhoneNumber(raw);
  if (!e164) {
    return { error: true, text: 'Nummer nicht erkennbar – bitte mit Vorwahl eingeben, z. B. 0176 12345678.' };
  }
  return { error: false, text: `Wird erkannt als ${formatE164ForDisplay(e164)}` };
}
